/* global clearInterval, console, setInterval */
const config = require("pa_config");
const hostUrl = config.API_URL;
// const hostUrl = "https://alfa.plutusanalytics.com/api/";
const validator = require("validator");
apiKey = localStorage.getItem("appKey");
apiSecret = localStorage.getItem("appSecret");
const passProtect = "plutusAnalytics";
const CALCULATE_COMPLETED_MESSAGE = "Calculation successful.";

function parseJsonResponse(responseText, fallbackValue = null) {
  if (typeof responseText !== "string") {
    return fallbackValue;
  }

  const trimmedResponse = responseText.trim();
  if (trimmedResponse.length === 0) {
    return fallbackValue;
  }

  return JSON.parse(trimmedResponse);
}

function ToDateStr(dateValue) {
  if (dateValue == null) {
    throw Error("Date value is required.");
  }

  if (dateValue instanceof Date) {
    if (Number.isNaN(dateValue.getTime())) {
      throw Error("Invalid date value.");
    }
    return dateValue.toISOString().substring(0, 10);
  }

  if (typeof dateValue === "string") {
    const trimmedDateValue = dateValue.trim();

    if (trimmedDateValue.length === 0) {
      throw Error("Date value is required.");
    }

    if (/^\d+(\.\d+)?$/.test(trimmedDateValue)) {
      const excelDate = new Date((Number(trimmedDateValue) - 25569) * 86400000);
      if (Number.isNaN(excelDate.getTime())) {
        throw Error("Invalid date value.");
      }
      return excelDate.toISOString().substring(0, 10);
    }

    if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(trimmedDateValue)) {
      const [year, month, day] = trimmedDateValue.split("-");
      const normalizedDate = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
      if (Number.isNaN(normalizedDate.getTime())) {
        throw Error("Invalid date value.");
      }
      return normalizedDate.toISOString().substring(0, 10);
    }

    const parsedDate = new Date(trimmedDateValue);
    if (Number.isNaN(parsedDate.getTime())) {
      throw Error(`Invalid date value: ${dateValue}`);
    }
    return parsedDate.toISOString().substring(0, 10);
  }

  if (typeof dateValue === "number") {
    const excelDate = new Date((dateValue - 25569) * 86400000);
    if (Number.isNaN(excelDate.getTime())) {
      throw Error("Invalid date value.");
    }
    return excelDate.toISOString().substring(0, 10);
  }

  throw Error(`Unsupported date value type: ${typeof dateValue}`);
}

async function LockSheet() {
  apiKey = localStorage.getItem("appKey");
  apiSecret = localStorage.getItem("appSecret");
  await Excel.run(async (ctx) => {
    let curSheet = ctx.workbook.worksheets.getActiveWorksheet();
    curSheet.load("protection/protected");
    await ctx.sync();
    if (!curSheet.protection.protected){
      var options = {
        allowAutoFilter : false,
        allowDeleteColumns : false,
        allowDeleteRows : false,
        allowEditObjects : false,
        allowEditScenarios : false,
        allowFormatCells : false,
        allowFormatColumns : false,
        allowFormatRows : false,
        allowInsertColumns : false,
        allowInsertHyperlinks : false,
        allowInsertRows : false,
        allowPivotTables : false,
        allowSort : false,
        selectionMode: "None"
      }
      curSheet.protection.protect(options, passProtect);
    }
    console.log("locked");
  });
}
async function UnlockSheet() {
  await Excel.run(async (ctx) => {
    let curSheet = ctx.workbook.worksheets.getActiveWorksheet();
    curSheet.load("protection/protected");
    await ctx.sync();
    //if (curSheet.protection.protected){
      curSheet.protection.unprotect(passProtect);
    //}
    console.log("unlocked");
  }).catch((err)=>{
    console.log(err);
  });
}  
async function FillData(startCol, endCol, startRow, rowCount, data){
  // console.log('function FillData: ',startCol, endCol, startRow, rowCount, data);
  await Excel.run(async (ctx) => {
    let curSheet = ctx.workbook.worksheets.getActiveWorksheet();
    curSheet.load("protection/protected");
    await ctx.sync();
    if (curSheet.protection.protected){
      curSheet.protection.unprotect(passProtect);
    }
    // Clear cells, "A8:K11"
    let rowsRange = curSheet.getRange(startCol + startRow.toString() + ":" + endCol + (startRow + rowCount - 1).toString());
    rowsRange.clear(Excel.ClearApplyTo.contents);
    // Fill data, "A8:k11"
    let showDataRange = curSheet.getRange(startCol + startRow.toString() + ":" + endCol + (startRow + rowCount - 1).toString());
    showDataRange.values = data;
    // console.log(curSheet.protection.protected);
    await ctx.sync(); 
    
  }).catch((err)=>{
    console.log(err);
  });
}

// Calculate mbs
function MBS(
  settlement_date, 
  cusips, 
  prices_or_oass, 
  invocation, 
  analytics_outputs = null, 
  mbs_strip = "MBS", 
  givenPrice = false, 
  shock = 0, 
  term_structure="SVSLN", 
  discounting="TSY",
  valuation_date=null, 
  custom_sofr_curve=null,
  custom_tsy_curve=null
  ) {
  try {
    var cellAddress = invocation.address.split("!");    // sheet1!A9
    const apiUrl = hostUrl + "mbs/umbs/";
    const CAL_ITEMS_TITLE = ["OAC", "OAD", "WAL", "Spread Duration", "Life CPR", "ZV Spread", "Vol Up 10", "Yield"];//For KRD, KRD1,KRD2,...,KRD7
    const CAL_FIELD_ITEMS = ["oac", "oad", "wal", "sprdur", "lcpr", "zvspread", "vol_up_10", "yield"];
    const VOL_TYPE = ["SV", "SVSLN"];
    const DISCOUNTING = ["TSY", "SOFR"];

    // Could use user term structure model
    if (term_structure == null){
      term_structure = "SVSLN";
    }
    // else if (!VOL_TYPE.includes(term_structure)){
    //   throw Error('The argument "term_structure" must be one of ["SV", "SVSLN"].');
    // }

    if (discounting == null){
      discounting = "TSY"
    }
    else if (!DISCOUNTING.includes(discounting)){
      throw Error('The argument "discounting" must be one of ["TSY", "SOFR"].');
    }
    // Lock current sheet.
    return LockSheet().then((res)=>{
      // Prepare post data for submitting tasks
      if (!shock){
        shock = 0;
      }
      var calItems = [];
      var calItemsTitle = [];
      var krds = [];
      if (analytics_outputs == null){
        calItems = CAL_FIELD_ITEMS;
        calItemsTitle = CAL_ITEMS_TITLE
      }
      else{
        analytics_outputs.forEach(r => {
          r.forEach(c => {
            let c_lowwer = c.toLowerCase();
            let idx = CAL_FIELD_ITEMS.indexOf(c_lowwer);
            let c_upper = c.toUpperCase();
            // console.log(c_upper);
            if (idx >= 0 && !calItems.includes(c_lowwer)) {
              calItems.push(c_lowwer);
              calItemsTitle.push(CAL_ITEMS_TITLE[idx]);
            }
            else if (c_upper.startsWith("KRD") && !krds.includes(c_upper)){
              krds.push(c_upper);
            }
          });
        });
      }
      if (mbs_strip == null){
        mbs_strip = "MBS";
      }
      else{
        mbs_strip = mbs_strip.toUpperCase();
      }
      var cusipArr = [];
      cusips.forEach(r => {
        r.forEach(c => {
          cusipArr.push(c);
        });
      });
      var priceoroasArr = [];
      prices_or_oass.forEach(r => {
        r.forEach(c => {
          priceoroasArr.push(c);
        });
      });
      var re = [];
      re.push(["No.", "CUSIP", "Price", "OAS"].concat(calItemsTitle).concat(krds));
      if (cusipArr.length != priceoroasArr.length){
        throw Error("The count of cusips must be the same as the count of OAS.");
      }
      var batchTask = {
        need_notify: false,
        use_own_data: false,
        use_own_hpi: false,
        use_cusip: true,
        given_price: givenPrice,
        valuation_date: valuation_date != null ? ToDateStr(valuation_date) : null,
        mbs_method: mbs_strip,
        checked_oac: calItems.includes("oac"),
        checked_oad: calItems.includes("oad"),
        checked_wal: calItems.includes("wal"),
        checked_sprdur: calItems.includes("sprdur"),
        checked_lcpr: calItems.includes("lcpr"),
        checked_zvspread: calItems.includes("zvspread"),
        checked_vol_up_10: calItems.includes("vol_up_10"),
        checked_yield: calItems.includes("yield"),
        vol_type: term_structure,
        discounting: discounting,
        checked_krd: krds.length > 0 ? krds : null,
        user_sofr_curve: custom_sofr_curve != null ? custom_sofr_curve : null,
        user_tsy_curve: custom_tsy_curve != null ? custom_tsy_curve : null,
        tasks: []
      };
      
      var sd = ToDateStr(settlement_date);
      for (let i = 0; i < cusips.length; i++){
        let task = {
          row_id: i.toString(),
          settlement_date: sd,
          cusip: cusipArr[i]
        }
        if (shock != 0){
          task['shocks'] = [shock];
        }
        if (givenPrice) {
          task["price"] = priceoroasArr[i];
        } else{
          task["oas"] = priceoroasArr[i];
        }
        let reItem = [i + 1, cusipArr[i], "", ""];
        calItems.forEach(ci => {
          reItem.push("")
        });
        krds.forEach(ci => {
          reItem.push("")
        });
        re.push(reItem);
        batchTask.tasks.push(task);
      };

      // console.log(re);
      // console.log(batchTask);
      // UnlockSheet();
      // return 0;
      
      // Submit tasks to plutus API, and get result
      if (batchTask.tasks.length <= 0){
        throw Error("No tasks submitted!");
      } else {
        //Send batch task request
        let xhttp = new XMLHttpRequest();
        let errMsg = "";
        return new Promise(function (resolve, reject){
          xhttp.onreadystatechange = function(){
            if (xhttp.readyState !== 4) return;
            if (xhttp.status >= 400){
              errMsg += "Status code: " + xhttp.status + "; \r\n" + xhttp.responseText;
              reject(errMsg);
            } else {
              let payload;
              try {
                payload = parseJsonResponse(xhttp.responseText, null);
              } catch (error) {
                reject("Unable to parse API response.");
                return;
              }

              if (!payload) {
                reject("Empty response received from API.");
                return;
              }

              if (payload["batch_id"]){
                batchTask["batch_id"] = payload["batch_id"];
                let taskCount = 0;
                batchTask.tasks.forEach(t=>{
                  let row_id = t.row_id;
                  if (payload.tasks[row_id]){
                    if (validator.isUUID(payload.tasks[row_id].toString())){
                      t["task_id"] = payload.tasks[row_id];
                      taskCount++;
                    }
                    else{
                      t["message"] = payload.tasks[row_id].toString();
                      re[parseInt(row_id) + 1][2] = t["message"];
                    }
                  }              
                });
                // console.log(batchTask, apiUrl);

                // Get calculate result
                per_page = 100;
                total_page = Math.ceil(taskCount / per_page);
                var base_query = apiUrl + "?batch_id=" + batchTask["batch_id"] + (shock == 0 ? "" : ("&shock=0&shock=" + shock.toString())) + "&per_page=" + per_page.toString();
                var queryCount = 0;         // Query count.
                var completedCount = 0;     // Completed task count 
                var refreshInterval = 30000; // Refresh data interval(microsecond).
                // console.log(apiUrl, base_query);
                // UnlockSheet();
                function queryResult(){
                  // console.log('queryResult begin counts: ', completedCount, taskCount, queryCount);
                  if (queryCount > 50 || completedCount >= taskCount){
                    return;
                  }
                  queryCount++;
                  completedCount = 0; 
                  var handledPageCount = 0;
                  for (let cur_page = 1; cur_page <= total_page; cur_page ++){
                    console.log("Page " + cur_page.toString() + " Start!"); 
                    let query = base_query + "&page=" + cur_page.toString();
                    let xhrResult = new XMLHttpRequest();
                    xhrResult.onreadystatechange = function(){
                      if (xhrResult.readyState !== 4) return;
                      // console.log(xhttp);
                      if (xhrResult.status < 400) {
                        let data;
                        try {
                          data = parseJsonResponse(xhrResult.responseText, []);
                        } catch (error) {
                          reject("Unable to parse API result response.");
                          return;
                        }

                        if (Array.isArray(data) && data.length > 0){
                          // Get computed result
                          base_tasks = data.filter((r) => r.shock == 0);
                          shock_tasks = data.filter((r) => r.shock != 0);
                          // console.log(base_tasks, shock_tasks);
                          base_tasks.forEach(tr => {
                            // console.log(tr);
                            if (tr.status == "SUCCESS"){
                              // When status of base task is cuccess, handle shock task data.
                              let st = shock_tasks.find((element) => element.base_shock_task_id == tr.id)
                              if (st === undefined){
                                st = tr;
                              } 
                              if (st.status == "SUCCESS" || st.status == "FAILURE"){
                                let t = batchTask.tasks.find((element) => element.task_id == tr.id);
                                if (t && t["task_id"]){
                                  completedCount++;
                                  t["status"] = st.status;
                                  let rowId = parseInt(t.row_id) + 1;
                                  if (st.status == "SUCCESS"){
                                    re[rowId][3] = st.oas;
                                    re[rowId][2] = st.price;
                                    for (let i = 0; i < calItems.length; i++){
                                      re[rowId][i + 4] = st[calItems[i] == "yield" ? "yield_val" : calItems[i]];
                                    }
                                    if (krds.length > 0){
                                      krd_vals = st['krd'];
                                      start = 4 + calItems.length;
                                      for (let i = 0; i < krds.length; i++){
                                        re[rowId][i + start] = krd_vals[i];
                                      }
                                    }
                                  } else if (tr.status == "FAILURE"){
                                    t["result"] = null;
                                    re[rowId][2] = "Calculate failed!";
                                  }
                                }
                              }
                            } else if (tr.status == "FAILURE"){
                              // When status of base task is failure, do not find shock task data.
                              let t = batchTask.tasks.find((element) => element.task_id == tr.id);
                              completedCount++;
                              t["status"] = "FAILURE";
                              let rowId = parseInt(t.row_id) + 1;
                              t["result"] = null;
                              re[rowId][2] = "Calculate failed!";
                            }
                          });
                          
                          // Show data to current sheet
                          // console.log('query result counts: ', completedCount, taskCount);
                          if (completedCount >= taskCount){
                            // Get show area
                            let rowCount = re.length;
                            let colCount = re[0].length - 1;
                            let startRow = /\d+/.exec(cellAddress[1])[0];
                            let startCol = /[A-Z]+/.exec(cellAddress[1])[0];
                            let endCol = startCol;
                            let colEndNum = endCol[endCol.length - 1].charCodeAt();
                            colEndNum += colCount - 1;
                            if (colEndNum > 90){
                              colEndNum -= 25; //colEndNum - 90 + 65;
                              if (startCol.length == 1){
                                endCol = "A" + String.fromCharCode(colEndNum);
                              } else if (col.length > 1){
                                // Only carry 1 bit.
                                let colNum = endCol[endCol.length - 2].charCodeAt();
                                colNum += 1;
                                endCol = String.fromCharCode(colNum) + String.fromCharCode(colEndNum);
                              }
                            } else {
                              if (endCol.length == 1){
                                endCol = String.fromCharCode(colEndNum);
                              } else if (col.length > 1){
                                endCol = endCol.substring(0, endCol.length - 1) + String.fromCharCode(colEndNum);
                              }
                            }
                            // console.log(re);
                            let fileData = re.map(function(val){
                              return val.slice(1);
                            });
                            FillData(startCol, endCol, parseInt(startRow) + 1, rowCount, fileData).finally(()=>{
                              handledPageCount++;
                              // console.log("handledPageCount: ", handledPageCount);
                              resolve(CALCULATE_COMPLETED_MESSAGE);
                            });
                          }
                        }
                      }
                      handledPageCount++;
                      if (handledPageCount >= total_page){
                        if (queryCount > 50){
                          reject("Over 50 queries were made.");
                        } else if (completedCount < taskCount){
                          setTimeout(() => {
                            queryResult();
                          }, refreshInterval);
                        }
                      }
                      console.log(cur_page.toString() + "finished!");
                    };
                    xhrResult.open("GET", query, true);
                    xhrResult.setRequestHeader("x-app-key", apiKey);
                    xhrResult.setRequestHeader("x-app-secret", apiSecret);
                    xhrResult.send(); 
                  };
                  // console.log(queryCount, tryCount, completedCount);
                };
                setTimeout(() => {
                  queryResult();
                }, refreshInterval);
              } else {
                errMsg += "Message: " + xhttp.responseText + "\r\n";
                reject(errMsg);
              }
            }
          }
          xhttp.open("POST", apiUrl, true);
          xhttp.setRequestHeader("Content-Type", "application/json");
          xhttp.setRequestHeader("x-app-key", apiKey);
          xhttp.setRequestHeader("x-app-secret", apiSecret);
          xhttp.send(JSON.stringify(batchTask));

        }).finally(()=>{
          UnlockSheet();
        });
      }      
    });
  } catch (error) {
    UnlockSheet();
    return error.toString();
  }
}

/**
 * Calculates the price and other user-specified metrics for an MBS based on OAS.
 * @customfunction 
 * @param {string} valuation_date This is the date on which the yield curve and its volatility are used to price the bonds, e.g., 6/28/2024. This should reference a single cell.
 * @param {string} settlement_date Settlement date. This should reference a single cell.
 * @param {string[][]} cusips CUSIP of the MBS to be priced.
 * @param {number[][]} oass This is the OAS of the bond in bps (e.g., 100 for 1%).
 * @param {number} [shock] Optional. Shock to the yield curve in bps (e.g., 100 for 1%). This should reference a single cell.
 * @param {string[][]} [analytics_outputs] Optional. Select the analytics to compute. The default output includes OAD, OAC, WAL, SPREAD DURATION, LIFE CPR, ZV SPREAD, VOL UP 10 and Yield. Available options: OAD, OAC, WAL, LCPR (for Life CPR), ZVSPREAD, VOL_UP_10, YIELD, KRD1, KRD2,…, KRD7 (representing key rate durations for seven maturity buckets) .
 * @param {string} [mbs_strip] Optional. Options include: MBS, IO and PO. The default is MBS.
 * @param {string} [term_structure] Optional. Specifies which term structure model to be used. Options include SV and SVSLN. The default option is SVSLN. SVSLN is a multi-factor stochastic volatility shifted log-normal HJM model. SV is a multi-factor stochastic volatility HJM model.
 * @param {string} [discounting] Specify the discounting curve. Options include SOFR and TSY. The default is TSY.
 * @param {string} [custom_sofr_curve] Optional. Specifies which user-defined SOFR curve to be used.
 * @param {string} [custom_tsy_curve] Optional. Specifies which user-defined TSY curve to be used for discounting.
 * @param {CustomFunctions.Invocation} invocation Invocation object.
 * @returns {string} Writes a result table below the calling cell and returns "Calculation successful." when successful.
 * @requiresAddress
 */
 function MBS_Price(valuation_date, settlement_date, cusips, oass, shock, analytics_outputs, mbs_strip, term_structure, discounting, custom_sofr_curve, custom_tsy_curve, invocation) {
  return MBS(
    settlement_date,  
    cusips, 
    oass, 
    invocation,
    analytics_outputs, 
    mbs_strip, 
    false, 
    shock, 
    term_structure, 
    discounting, 
    valuation_date, 
    custom_sofr_curve,
    custom_tsy_curve
    );
 }

 /**
 * Calculates the OAS and other user-specified metrics for an MBS based on price.
 * @customfunction 
 * @param {string} valuation_date This is the date on which the yield curve and its volatility are used to price the bonds, e.g., 6/28/2024. This should reference a single cell.
 * @param {string} settlement_date Settlement date. This should reference a single cell.
 * @param {string[][]} cusips CUSIP of the MBS to be priced.
 * @param {number[][]} prices This is the price of the bond per $100 of par value (e.g., 101.25).
 * @param {number} [shock] Optional. Shock to the yield curve in bps (e.g., 100 for 1%). This should reference a single cell.
 * @param {string[][]} [analytics_outputs] Optional. Select the analytics to compute. The default output includes OAD, OAC, WAL, SPREAD DURATION, LIFE CPR, ZV SPREAD, VOL UP 10 and Yield. Available options: OAD, OAC, WAL, LCPR (for Life CPR), ZVSPREAD, VOL_UP_10, YIELD, KRD1, KRD2,…, KRD7 (representing key rate durations for seven maturity buckets) .
 * @param {string} [mbs_strip] Optional. Options include: MBS, IO and PO. The default is MBS.
 * @param {string} [term_structure] Optional. Specifies which term structure model to be used. Options include SV and SVSLN. The default option is SVSLN. SVSLN is a multi-factor stochastic volatility shifted log-normal HJM model. SV is a multi-factor stochastic volatility HJM model.
 * @param {string} [discounting] Specify the discounting curve. Options include SOFR and TSY. The default is TSY.
 * @param {string} [custom_sofr_curve] Optional. Specifies which user-defined SOFR curve to be used.
 * @param {string} [custom_tsy_curve] Optional. Specifies which user-defined TSY curve to be used for discounting.
 * @param {CustomFunctions.Invocation} invocation Invocation object.
 * @returns {string} Writes a result table below the calling cell and returns "Calculation successful." when successful.
 * @requiresAddress
 */
function MBS_OAS(valuation_date, settlement_date, cusips, prices, shock, analytics_outputs, mbs_strip, term_structure, discounting, custom_sofr_curve, custom_tsy_curve, invocation) {
  // console.log("valuation_date: ", valuation_date);
  // console.log("settlement_date: ", settlement_date);
  // console.log("cusips: ", cusips);
  // console.log("prices: ", prices);
  // console.log("shock: ", shock);
  // console.log("analytics_outputs: ", analytics_outputs);
  // console.log("mbs_strip: ", mbs_strip);
  // console.log("term_structure: ", term_structure);
  // console.log("discounting: ", discounting);
  // console.log("invocation: ", invocation);
  return MBS(
    settlement_date,  
    cusips, 
    prices, 
    invocation,
    analytics_outputs, 
    mbs_strip, 
    true, 
    shock, 
    term_structure, 
    discounting, 
    valuation_date, 
    custom_sofr_curve,
    custom_tsy_curve
    );
}

const FIELD_INFO = {
  "price": "Price",
  "oas": "OAS",
  "yield_val": "Yield",
  "duration": "Duration",
  "convexity": "Convexity",
  "yield_maturity": "Yield to Maturity",
  "yield_call": "Yield to Call",
  "discount_margin": "Discount Margin",
  "impbkvol": "Implied Black Vol",
}

function Rate_Prod_Calculate(batchTask, apiUrl, cellAddress, resultItemNames=[]){
  try {
    if (resultItemNames.length <= 0){
      resultItemNames = ["price", "duration", "convexity"];
    }
    var re = [];
    // re.push(["No.", "Price", "Duration", "Convexity"]);
    var rei = ["No."];
    resultItemNames.forEach(rin => {
      rei.push(FIELD_INFO[rin]);
    })
    re.push(rei);
    console.log(re, resultItemNames);
    // Result lines
    for (let i = 0; i < batchTask.tasks.length; i++){
      let reItem = [i + 1];
      resultItemNames.forEach(ci => {
        reItem.push("")
      });
      re.push(reItem);
    };
    //Send batch task request
    let xhttp = new XMLHttpRequest();
    let errMsg = "";
    return new Promise(function (resolve, reject){
      xhttp.onreadystatechange = function(){
        if (xhttp.readyState !== 4) return;
        if (xhttp.status >= 400){
          errMsg += "Status code: " + xhttp.status + "; \r\n" + xhttp.responseText;
          reject(errMsg);
        } else {
          let payload;
          try {
            payload = parseJsonResponse(xhttp.responseText, null);
          } catch (error) {
            reject("Unable to parse API response.");
            return;
          }

          if (!payload) {
            reject("Empty response received from API.");
            return;
          }

          // console.log(payload);
          if (payload["batch_id"]){
            batchTask["batch_id"] = payload["batch_id"];
            let taskCount = 0;
            batchTask.tasks.forEach(t=>{
              let row_id = t.row_id;
              if (payload.tasks[row_id]){
                if (Array.isArray(payload.tasks[row_id])){
                  t["message"] = JSON.stringify(payload.tasks[row_id]);
                  re[parseInt(row_id) + 1][1] = t["message"];
                }
                else if (validator.isUUID(payload.tasks[row_id])){
                  t["task_id"] = payload.tasks[row_id];
                  taskCount++;
                }
                else{
                  t["message"] = payload.tasks[row_id];
                  re[parseInt(row_id) + 1][1] = t["message"];
                }
              }              
            });
            // console.log(batchTask);

            // Get calculate result
            per_page = 500;
            total_page = Math.ceil(taskCount / per_page);
            let base_query = apiUrl + "?batch_id=" + batchTask["batch_id"] + "&per_page=" + per_page.toString();
            let queryCount = 0;         // Query count.
            let completedCount = 0;     // Completed task count 
            let refreshInterval = 5000; // Refresh data interval(microsecond).
            // console.log(query);

            function queryResult(){
              if (queryCount > 50 || completedCount >= taskCount){
                return;
              }
              queryCount++;
              completedCount = 0; 
              var handledPageCount = 0;
              for (let cur_page = 1; cur_page <= total_page; cur_page ++){
                // console.log(cur_page.toString() + "Start!");
                let query = base_query + "&page=" + cur_page.toString();
                let xhrResult = new XMLHttpRequest();
                xhrResult.onreadystatechange = function(){
                  if (xhrResult.readyState !== 4) return;
                  if (xhrResult.status < 400) {
                    let data;
                    try {
                      data = parseJsonResponse(xhrResult.responseText, []);
                    } catch (error) {
                      reject("Unable to parse API result response.");
                      return;
                    }

                    if (Array.isArray(data) && data.length > 0){
                      // Get computed result
                      data.forEach(tr => {
                        if (tr.status == "SUCCESS" || tr.status == "FAILURE"){
                          batchTask.tasks.some(t => {
                            if (t["task_id"] && t.task_id == tr.id){
                              completedCount++;
                              t["status"] = tr.status;
                              let rowId = parseInt(t.row_id) + 1;
                              if (tr.status == "SUCCESS"){
                                for (let i = 0; i < resultItemNames.length; i++){
                                  re[rowId][i + 1] = tr[resultItemNames[i]];
                                }
                              }
                              else if (tr.status == "FAILURE"){
                                t["result"] = null;
                                re[rowId][1] = "Calculate failed!"
                              }
                            }
                          });
                        }
                      });
                      
                      // Show data to current sheet
                      // console.log(completedCount, taskCount);
                      if (completedCount >= taskCount){
                        // Get show area
                        let rowCount = re.length;
                        let colCount = re[0].length - 1;
                        let startRow = /\d+/.exec(cellAddress[1])[0];
                        let startCol = /[A-Z]+/.exec(cellAddress[1])[0];
                        let endCol = startCol;
                        let colEndNum = endCol[endCol.length - 1].charCodeAt();
                        colEndNum += colCount - 1;
                        if (colEndNum > 90){
                          colEndNum -= 25; //colEndNum - 90 + 65;
                          if (startCol.length == 1){
                            endCol = "A" + String.fromCharCode(colEndNum);
                          } else if (col.length > 1){
                            // Only carry 1 bit.
                            let colNum = endCol[endCol.length - 2].charCodeAt();
                            colNum += 1;
                            endCol = String.fromCharCode(colNum) + String.fromCharCode(colEndNum);
                          }
                        } else {
                          if (endCol.length == 1){
                            endCol = String.fromCharCode(colEndNum);
                          } else if (col.length > 1){
                            endCol = endCol.substring(0, endCol.length - 1) + String.fromCharCode(colEndNum);
                          }
                        }
                        // console.log(re);
                        let fileData = re.map(function(val){
                          return val.slice(1);
                        });
                        FillData(startCol, endCol, parseInt(startRow) + 1, rowCount, fileData).finally(()=>{
                          handledPageCount++;
                          resolve(CALCULATE_COMPLETED_MESSAGE);
                        });
                      }
                    }
                  }
                  handledPageCount++;
                  if (handledPageCount >= total_page){
                    if (queryCount > 50){
                      reject("Over 50 queries were made.");
                    } else if (completedCount < taskCount){
                      setTimeout(() => {
                        queryResult();
                      }, refreshInterval);
                    }
                  }
                  // console.log(cur_page.toString() + "finished!");
                };
                xhrResult.open("GET", query, true);
                xhrResult.setRequestHeader("x-app-key", apiKey);
                xhrResult.setRequestHeader("x-app-secret", apiSecret);
                xhrResult.send();
              };
              // console.log(queryCount, tryCount, completedCount);
            };
            setTimeout(() => {
              queryResult();
            }, refreshInterval);
          } else {
            errMsg += "Message: " + xhttp.responseText + "\r\n";
            reject(errMsg);
          }
        }
      }
      xhttp.open("POST", apiUrl, true);
      xhttp.setRequestHeader("Content-Type", "application/json");
      xhttp.setRequestHeader("x-app-key", apiKey);
      xhttp.setRequestHeader("x-app-secret", apiSecret);
      xhttp.send(JSON.stringify(batchTask));

    }).finally(()=>{
      UnlockSheet();
    });    
  } catch (error) {
    UnlockSheet();
    return error.toString();
  }

}

function European_Callable(
  valuation_date, 
  price_or_oass, 
  lockouts, 
  maturities, 
  coupons, 
  intervals, 
  given_price=true,
  term_structure='SVSLN', 
  custom_yield_curve=null,
  yield_curve="SOFR",
  invocation){

  return LockSheet().then((res)=>{
    try {
      const apiUrl = hostUrl + "fixedincomeproduct/e_callable/";
      var cellAddress = invocation.address.split("!");    // sheet1!A9
      var poArr = [];
      price_or_oass.forEach(r => {
        r.forEach(c => {
          poArr.push(c);
        });
      });
      var lockoutArr = [];
      lockouts.forEach(r => {
        r.forEach(c => {
          lockoutArr.push(c);
        });
      });
      var maturityArr = [];
      maturities.forEach(r => {
        r.forEach(c => {
          maturityArr.push(c);
        });
      });

      var couponArr = [];
      coupons.forEach(r => {
        r.forEach(c => {
          couponArr.push(c);
        });
      });

      var intervalArr = [];
      intervals.forEach(r => {
        r.forEach(c => {
          intervalArr.push(c);
        });
      });

      if (lockoutArr.length != maturityArr.length || 
          lockoutArr.length != couponArr.length || 
          lockoutArr.length != intervalArr.length || 
          lockoutArr.length != poArr.length){
        throw Error("The lengths of the task's parameters are not equal.")
      }
      var batchTask = {
        need_notify: false,
        use_own_data: false,
        valuation_date: valuation_date != null ? ToDateStr(valuation_date) : null,
        vol_type: term_structure == null ? "SVSLN" : term_structure,
        user_sofr_curve: custom_yield_curve != null ? custom_yield_curve : null,
        yield_curve: yield_curve != null ? yield_curve : (custom_yield_curve != null ? "Use Custom Yield Curve" : "SOFR"),
        given_price: given_price,
        tasks: []
      };
      for (let i = 0; i < lockoutArr.length; i++){
        var task = {
          row_id: i.toString(),
          lockout: lockoutArr[i],
          maturity: maturityArr[i],
          coupon: couponArr[i],
          interval: intervalArr[i]
        };
        if (given_price){
          task["price"] = poArr[i];
        }
        else{
          task["oas"] = poArr[i];
        }
        batchTask.tasks.push(task);
      };
      //return JSON.stringify(batchTask);

      // Submit tasks to plutus API, and get result
      if (batchTask.tasks.length <= 0){
        throw Error("No tasks submitted!");
      } else {
        if (given_price){
          return Rate_Prod_Calculate(batchTask, apiUrl, cellAddress, ['oas', 'duration', 'convexity', 'yield_maturity', 'yield_call']);
        }
        return Rate_Prod_Calculate(batchTask, apiUrl, cellAddress, ['price', 'duration', 'convexity', 'yield_maturity', 'yield_call']);
      }      
    } catch (error) {
      UnlockSheet();
      return error.toString();
    }
  });
}

 /**
 * This function computes the OAS for European Callable Bond(s) based on their price(s). The function returns the OAS, duration, convexity, yield to maturity and yield to call. 
 * @customfunction 
 * @param {string} valuation_date This is the date on which the yield curve and its volatility are used to price the bonds, e.g., 6/28/2024. This should reference a single cell.
 * @param {number[][]} prices This is the price of the bond per $100 of par value (e.g., 101.25).
 * @param {number[][]} lockouts This is the lockout period of the option, measured in years. For example, 2.5 means the lockout period is 2.5 years.
 * @param {number[][]} maturities This is the maturity of the bond, measured in years. For example, 5.5 means the bond will mature in 5.5 years.
 * @param {number[][]} coupons Coupon rate (e.g., 5 for 5%).
 * @param {number[][]} intervals This is the coupon payment interval, measured in years. For example, 0.5 means the coupon is paid ever 6 months.
 * @param {string} [term_structure] Optional. Specifies which term structure model to be used. Options include SV and SVSLN. The default option is SVSLN. SVSLN is a multi-factor stochastic volatility shifted log-normal HJM model. SV is a multi-factor stochastic volatility HJM model.
 * @param {string} [custom_yield_curve] Optional. Specifies which user-defined yield curve to be used.
 * @param {string} [yield_curve] Optional. Specifies the yield curve to use. Options include SOFR, Treasury, AAA, AA, A, BBB, BB, B, CCC, and "Use Custom Yield Curve". The default is SOFR.
 * @param {CustomFunctions.Invocation} invocation Invocation object.
 * @returns {string} Writes valuation results below the calling cell and returns "Calculation successful." when successful.
 * @requiresAddress
 */
function European_Callable_OAS(valuation_date, prices, lockouts, maturities, coupons, intervals, term_structure, custom_yield_curve, yield_curve, invocation) {
  // Lock current sheet.
  return European_Callable(valuation_date, prices, lockouts, maturities, coupons, intervals, true, term_structure, custom_yield_curve, yield_curve, invocation);
}

/**
 * This function computes the price for European Callable Bond(s) based on their OAS(s). The function returns the price, duration, convexity, yield to maturity and yield to call. 
 * @customfunction 
 * @param {string} valuation_date This is the date on which the yield curve and its volatility are used to price the bonds, e.g., 6/28/2024. This should reference a single cell.
 * @param {number[][]} oass This is the OAS of the bond in bps (e.g., 100 for 1%).
 * @param {number[][]} lockouts This is the lockout period of the option, measured in years. For example, 2.5 means the lockout period is 2.5 years.
 * @param {number[][]} maturities This is the maturity of the bond, measured in years. For example, 5.5 means the bond will mature in 5.5 years.
 * @param {number[][]} coupons Coupon rate (e.g., 5 for 5%).
 * @param {number[][]} intervals This is the coupon payment interval, measured in years. For example, 0.5 means the coupon is paid ever 6 months.
 * @param {string} [term_structure] Optional. Specifies which term structure model to be used. Options include SV and SVSLN. The default option is SVSLN. SVSLN is a multi-factor stochastic volatility shifted log-normal HJM model. SV is a multi-factor stochastic volatility HJM model.
 * @param {string} [custom_yield_curve] Optional. Specifies which user-defined yield curve to be used.
 * @param {string} [yield_curve] Optional. Specifies the yield curve to use. Options include SOFR, Treasury, AAA, AA, A, BBB, BB, B, CCC, and "Use Custom Yield Curve". The default is SOFR.
 * @param {CustomFunctions.Invocation} invocation Invocation object.
 * @returns {string} Writes valuation results below the calling cell and returns "Calculation successful." when successful.
 * @requiresAddress
 */
function European_Callable_Price(valuation_date, oass, lockouts, maturities, coupons, intervals, term_structure, custom_yield_curve, yield_curve, invocation) {
  // Lock current sheet.
  return European_Callable(valuation_date, oass, lockouts, maturities, coupons, intervals, false, term_structure, custom_yield_curve, yield_curve, invocation);
}

/**
 * This function returns the yield, duration, and convexity for a fixed-rate bullet bond. 
 * @customfunction 
 * @param {number[][]} prices This is the price of the bond per $100 of par value (e.g., 101.25).
 * @param {number[][]} coupons Coupon rate (e.g., 5 for 5%).
 * @param {number[][]} maturities This is the maturity of the bond, measured in years. For example, 5.5 means the bond will mature in 5.5 years.
 * @param {number[][]} intervals This is the coupon payment interval, measured in years. For example, 0.5 means the coupon is paid ever 6 months.
 * @param {CustomFunctions.Invocation} invocation Invocation object.
 * @returns {string} Writes valuation results below the calling cell and returns "Calculation successful." when successful.
 * @requiresAddress
 */
function Fixed_Rate_Bullet(prices, coupons, maturities, intervals, invocation) {

  // Lock current sheet.
  return LockSheet().then((res)=>{
    try {
      const apiUrl = hostUrl + "fixedincomeproduct/fixed_rate_bullet/";
      var cellAddress = invocation.address.split("!");    // sheet1!A9
      var priceArr = [];
      prices.forEach(r => {
        r.forEach(c => {
          priceArr.push(c);
        });
      });

      var couponArr = [];
      coupons.forEach(r => {
        r.forEach(c => {
          couponArr.push(c);
        });
      });

      var maturityArr = [];
      maturities.forEach(r => {
        r.forEach(c => {
          maturityArr.push(c);
        });
      });

      var intervalArr = [];
      intervals.forEach(r => {
        r.forEach(c => {
          intervalArr.push(c);
        });
      });

      if (maturityArr.length != couponArr.length || 
          maturityArr.length != intervalArr.length || 
          maturityArr.length != priceArr.length){
        throw Error("The lengths of the task's parameters are not equal.")
      }
      var batchTask = {
        need_notify: false,
        use_own_data: false,
        tasks: []
      };
      for (let i = 0; i < maturityArr.length; i++){
        var task = {
          row_id: i.toString(),
          price: priceArr[i],
          coupon: couponArr[i],
          maturity: maturityArr[i],
          interval: intervalArr[i]
        };
        batchTask.tasks.push(task);
      };
      //return JSON.stringify(batchTask);

      // Submit tasks to plutus API, and get result
      if (batchTask.tasks.length <= 0){
        throw Error("No tasks submitted!");
      } else {
        return Rate_Prod_Calculate(batchTask, apiUrl, cellAddress, ['yield_val', 'duration', 'convexity']);
      }
    } catch (error) {
      UnlockSheet();
      return error.toString();
    }
  });
}

/**
 * This function returns the discount margin, duration, and convexity for a floating rate bond. 
 * @customfunction 
 * @param {string} valuation_date This is the date on which the yield curve and its volatility are used to price the bonds, e.g., 6/28/2024. This should reference a single cell.
 * @param {number[][]} prices This is the price of the bond per $100 of par value (e.g., 101.25).
 * @param {number[][]} maturities This is the maturity of the bond, measured in years. For example, 5.5 means the bond will mature in 5.5 years.
 * @param {number[][]} intervals This is the coupon payment interval, measured in years. For example, 0.5 means the coupon is paid ever 6 months.
 * @param {number[][]} margins Coupon margin in bps (e.g., 225 for 2.25%).
 * @param {number[][]} [coupons] Optional. Initial coupon payment in percentage (e.g., 3.5 for 3.5%).
 * @param {string} [custom_yield_curve] Optional. Specifies which user-defined yield curve to be used.
 * @param {string} [yield_curve] Optional. Specifies the yield curve to use. Options include SOFR, Treasury, AAA, AA, A, BBB, BB, B, CCC, and "Use Custom Yield Curve". The default is SOFR.
 * @param {CustomFunctions.Invocation} invocation Invocation object.
 * @returns {string} Writes valuation results below the calling cell and returns "Calculation successful." when successful.
 * @requiresAddress
 */
 function Floater(valuation_date, prices, maturities, intervals, margins, coupons, custom_yield_curve, yield_curve, invocation) {

  // Lock current sheet.
  return LockSheet().then((res)=>{
    try {
      const apiUrl = hostUrl + "fixedincomeproduct/floater/";
      var cellAddress = invocation.address.split("!");    // sheet1!A9
      var priceArr = [];
      prices.forEach(r => {
        r.forEach(c => {
          priceArr.push(c);
        });
      });

      var maturityArr = [];
      maturities.forEach(r => {
        r.forEach(c => {
          maturityArr.push(c);
        });
      });

      var intervalArr = [];
      intervals.forEach(r => {
        r.forEach(c => {
          intervalArr.push(c);
        });
      });

      var marginArr = [];
      margins.forEach(r => {
        r.forEach(c => {
          marginArr.push(c);
        });
      });

      var couponArr = [];
      if (coupons != null && coupons.length > 0){
        coupons.forEach(r => {
          r.forEach(c => {
            couponArr.push(c);
          });
        });
      }

      if (maturityArr.length != marginArr.length || 
          maturityArr.length != intervalArr.length || 
          maturityArr.length != priceArr.length){
        throw Error("The lengths of the task's parameters are not equal.")
      }
      var batchTask = {
        need_notify: false,
        use_own_data: false,
        valuation_date: valuation_date != null ? ToDateStr(valuation_date) : null,
        user_sofr_curve: custom_yield_curve != null ? custom_yield_curve : null,
        yield_curve: yield_curve != null ? yield_curve : (custom_yield_curve != null ? "Use Custom Yield Curve" : "SOFR"),
        tasks: []
      };
      for (let i = 0; i < maturityArr.length; i++){
        var task = {
          row_id: i.toString(),
          price: priceArr[i],
          maturity: maturityArr[i],
          margin: marginArr[i],
          interval: intervalArr[i]
        };
        if (couponArr.length > 0){
          task.coupon = couponArr[i];
        }
        batchTask.tasks.push(task);
      };
      //return JSON.stringify(batchTask);

      // Submit tasks to plutus API, and get result
      if (batchTask.tasks.length <= 0){
        throw Error("No tasks submitted!");
      } else {
        return Rate_Prod_Calculate(batchTask, apiUrl, cellAddress, ['discount_margin', 'duration', 'convexity']);
      }
    } catch (error) {
      UnlockSheet();
      return error.toString();
    }
  });
}

/**
 * This function returns the discount margin, duration, and convexity for a floating rate bond with floor. 
 * @customfunction 
 * @param {string} valuation_date This is the date on which the yield curve and its volatility are used to price the bonds, e.g., 6/28/2024. This should reference a single cell.
 * @param {number[][]} prices This is the price of the bond per $100 of par value (e.g., 101.25).
 * @param {number[][]} maturities This is the maturity of the bond, measured in years. For example, 5.5 means the bond will mature in 5.5 years.
 * @param {number[][]} intervals This is the coupon payment interval, measured in years. For example, 0.5 means the coupon is paid ever 6 months.
 * @param {number[][]} margins Coupon margin in bps (e.g., 225 for 2.25%).
 * @param {number[][]} [floors] Floor of the coupon in percentage (e.g., 1.0 for 1.0%).
 * @param {number[][]} [coupons] Optional. Initial coupon payment in percentage (e.g., 3.5 for 3.5%).
 * @param {string} [term_structure] Optional. Specifies which term structure model to be used. Options include SV and SVSLN. The default option is SVSLN. SVSLN is a multi-factor stochastic volatility shifted log-normal HJM model. SV is a multi-factor stochastic volatility HJM model.
 * @param {string} [custom_yield_curve] Optional. Specifies which user-defined yield curve to be used.
 * @param {string} [yield_curve] Optional. Specifies the yield curve to use. Options include SOFR, Treasury, AAA, AA, A, BBB, BB, B, CCC, and "Use Custom Yield Curve". The default is SOFR.
 * @param {CustomFunctions.Invocation} invocation Invocation object.
 * @returns {string} Writes valuation results below the calling cell and returns "Calculation successful." when successful.
 * @requiresAddress
 */
 function Floater_With_Floor(valuation_date, prices, maturities, intervals, margins, floors, coupons, term_structure, custom_yield_curve, yield_curve, invocation) {
  // Lock current sheet.
  return LockSheet().then((res)=>{
    try {
      const apiUrl = hostUrl + "fixedincomeproduct/floater_floor/";
      var cellAddress = invocation.address.split("!");    // sheet1!A9
      var priceArr = [];
      prices.forEach(r => {
        r.forEach(c => {
          priceArr.push(c);
        });
      });

      var maturityArr = [];
      maturities.forEach(r => {
        r.forEach(c => {
          maturityArr.push(c);
        });
      });

      var intervalArr = [];
      intervals.forEach(r => {
        r.forEach(c => {
          intervalArr.push(c);
        });
      });

      var marginArr = [];
      margins.forEach(r => {
        r.forEach(c => {
          marginArr.push(c);
        });
      });

      var floorArr = [];
      if (floors != null && floors.length > 0){
        floors.forEach(r => {
          r.forEach(c => {
            floorArr.push(c);
          });
        });
      }

      var couponArr = [];
      if (coupons != null && coupons.length > 0){
        coupons.forEach(r => {
          r.forEach(c => {
            couponArr.push(c);
          });
        });
      }

      if (maturityArr.length != marginArr.length || 
          maturityArr.length != intervalArr.length || 
          maturityArr.length != priceArr.length){
        throw Error("The lengths of the task's parameters are not equal.")
      }
      var batchTask = {
        need_notify: false,
        use_own_data: false,
        valuation_date: valuation_date != null ? ToDateStr(valuation_date) : null,
        vol_type: term_structure == null ? "SVSLN" : term_structure,
        user_sofr_curve: custom_yield_curve != null ? custom_yield_curve : null,
        yield_curve: yield_curve != null ? yield_curve : (custom_yield_curve != null ? "Use Custom Yield Curve" : "SOFR"),
        tasks: []
      };
      for (let i = 0; i < maturityArr.length; i++){
        var task = {
          row_id: i.toString(),
          price: priceArr[i],
          maturity: maturityArr[i],
          margin: marginArr[i],
          interval: intervalArr[i]
        };
        if (floorArr.length > 0){
          task.floor = floorArr[i];
        }
        if (couponArr.length > 0){
          task.coupon = couponArr[i];
        }
        batchTask.tasks.push(task);
      };
      //return JSON.stringify(batchTask);

      // Submit tasks to plutus API, and get result
      if (batchTask.tasks.length <= 0){
        throw Error("No tasks submitted!");
      } else {
        return Rate_Prod_Calculate(batchTask, apiUrl, cellAddress, ['discount_margin', 'duration', 'convexity']);
      }      
    } catch (error) {
      UnlockSheet();
      return error.toString();
    }
  });
}

function Bermudan_Callable(
  valuation_date, 
  price_or_oass, 
  lockouts, 
  maturities, 
  coupons, 
  intervals, 
  given_price=true,
  term_structure='SVSLN', 
  custom_yield_curve=null, 
  yield_curve=null,
  invocation) {
  
    // Lock current sheet.
    return LockSheet().then((res)=>{
      try {
        const apiUrl = hostUrl + "fixedincomeproduct/berm_callable/";
        var cellAddress = invocation.address.split("!");    // sheet1!A9
        var poArr = [];
        price_or_oass.forEach(r => {
          r.forEach(c => {
            poArr.push(c);
          });
        });
  
        var lockoutArr = [];
        lockouts.forEach(r => {
          r.forEach(c => {
            lockoutArr.push(c);
          });
        });
        var maturityArr = [];
        maturities.forEach(r => {
          r.forEach(c => {
            maturityArr.push(c);
          });
        });
    
        var couponArr = [];
        coupons.forEach(r => {
          r.forEach(c => {
            couponArr.push(c);
          });
        });
    
        var intervalArr = [];
        intervals.forEach(r => {
          r.forEach(c => {
            intervalArr.push(c);
          });
        });
    
        if (lockoutArr.length != maturityArr.length || 
            lockoutArr.length != couponArr.length || 
            lockoutArr.length != intervalArr.length || 
            lockoutArr.length != poArr.length){
          throw Error("The lengths of the task's parameters are not equal.")
        }
        var batchTask = {
          need_notify: false,
          use_own_data: false,
          valuation_date: valuation_date != null ? ToDateStr(valuation_date) : null,
          vol_type: term_structure == null ? "SVSLN" : term_structure,
          user_sofr_curve: custom_yield_curve != null ? custom_yield_curve : null,
          yield_curve: yield_curve != null ? yield_curve : (custom_yield_curve != null ? "Use Custom Yield Curve" : "SOFR"),
          given_price: given_price,
          tasks: []
        };
        for (let i = 0; i < lockoutArr.length; i++){
          var task = {
            row_id: i.toString(),
              lockout: lockoutArr[i],
            maturity: maturityArr[i],
            coupon: couponArr[i],
            interval: intervalArr[i]
          };
          if (given_price){
            task["price"] = poArr[i];
          } else {
            task["oas"] = poArr[i];
          }
          batchTask.tasks.push(task);
        };
        //return JSON.stringify(batchTask);
    
        // Submit tasks to plutus API, and get result
        if (batchTask.tasks.length <= 0){
          throw Error("No tasks submitted!");
        } else {
          if (given_price){
            return Rate_Prod_Calculate(batchTask, apiUrl, cellAddress, ['oas', 'duration', 'convexity', 'yield_maturity', 'yield_call']);
          } 
          return Rate_Prod_Calculate(batchTask, apiUrl, cellAddress, ['price', 'duration', 'convexity', 'yield_maturity', 'yield_call']);
        }
      } catch (error) {
        UnlockSheet();
        return error.toString();
      }
    });
  }

/**
 * This function computes the OAS for Bermudan Callable Bond(s) based on their price(s). The function returns the OAS, duration, convexity, yield to maturity and yield to call.
 * @customfunction 
 * @param {string} valuation_date This is the date on which the yield curve and its volatility are used to price the bonds, e.g., 6/28/2024. This should reference a single cell.
 * @param {number[][]} prices This is the price of the bond per $100 of par value (e.g., 101.25).
 * @param {number[][]} lockouts This is the lockout period of the callable bond, measured in years. For example, 2.5 means the lockout period is 2.5 years.
 * @param {number[][]} maturities This is the maturity of the bond, measured in years. For example, 5.5 means the bond will mature in 5.5 years.
 * @param {number[][]} coupons Coupon rate (e.g., 5 for 5%).
 * @param {number[][]} intervals This is the coupon payment interval, measured in years. For example, 0.5 means the coupon is paid ever 6 months.
 * @param {string} [term_structure] Optional. Specifies which term structure model to be used. Options include SV and SVSLN. The default option is SVSLN. SVSLN is a multi-factor stochastic volatility shifted log-normal HJM model. SV is a multi-factor stochastic volatility HJM model.
 * @param {string} [custom_yield_curve] Optional. Specifies which user-defined yield curve to be used.
 * @param {string} [yield_curve] Optional. Specifies the yield curve to use. Options include SOFR, Treasury, AAA, AA, A, BBB, BB, B, CCC, and "Use Custom Yield Curve". The default is SOFR.
 * @param {CustomFunctions.Invocation} invocation Invocation object.
 * @returns {string} Writes valuation results below the calling cell and returns "Calculation successful." when successful.
 * @requiresAddress
 */
  function Bermudan_Callable_OAS(valuation_date, prices, lockouts, maturities, coupons, intervals, term_structure, custom_yield_curve, yield_curve, invocation) {
  
    // Lock current sheet.
    return Bermudan_Callable(valuation_date, prices, lockouts, maturities, coupons, intervals, true, term_structure, custom_yield_curve, yield_curve, invocation);
  }

/**
 * This function computes the price for Bermudan Callable Bond(s) based on their OAS(s). The function returns the price, duration, convexity, yield to maturity and yield to call.
 * @customfunction 
 * @param {string} valuation_date This is the date on which the yield curve and its volatility are used to price the bonds, e.g., 6/28/2024. This should reference a single cell.
 * @param {number[][]} oass This is the OAS of the bond in bps (e.g., 100 for 1%).
 * @param {number[][]} lockouts This is the lockout period of the callable bond, measured in years. For example, 2.5 means the lockout period is 2.5 years.
 * @param {number[][]} maturities This is the maturity of the bond, measured in years. For example, 5.5 means the bond will mature in 5.5 years.
 * @param {number[][]} coupons Coupon rate (e.g., 5 for 5%).
 * @param {number[][]} intervals This is the coupon payment interval, measured in years. For example, 0.5 means the coupon is paid ever 6 months.
 * @param {string} [term_structure] Optional. Specifies which term structure model to be used. Options include SV and SVSLN. The default option is SVSLN. SVSLN is a multi-factor stochastic volatility shifted log-normal HJM model. SV is a multi-factor stochastic volatility HJM model.
 * @param {string} [custom_yield_curve] Optional. Specifies which user-defined yield curve to be used.
 * @param {string} [yield_curve] Optional. Specifies the yield curve to use. Options include SOFR, Treasury, AAA, AA, A, BBB, BB, B, CCC, and "Use Custom Yield Curve". The default is SOFR.
 * @param {CustomFunctions.Invocation} invocation Invocation object.
 * @returns {string} Writes valuation results below the calling cell and returns "Calculation successful." when successful.
 * @requiresAddress
 */
  function Bermudan_Callable_Price(valuation_date, oass, lockouts, maturities, coupons, intervals, term_structure, custom_yield_curve, yield_curve, invocation) {
  
    // Lock current sheet.
    return Bermudan_Callable(valuation_date, oass, lockouts, maturities, coupons, intervals, false, term_structure, custom_yield_curve, yield_curve, invocation);
  }

/**
 * This function computes the price for interest rate swaps and outputs price, duration and convexity. 
 * @customfunction 
 * @param {string} valuation_date This is the date on which the yield curve and its volatility are used to price the bonds, e.g., 6/28/2024. This should reference a single cell.
 * @param {string} start_date Defines the start date of the interest rate swap. Future dates indicate forward-start swaps.
 * @param {number[][]} terms The remaining term of the swap in years. For example, 5.3 means the remaining term of the swap is 5.3 years.
 * @param {number[][]} swap_rates The swap rate of the fixed leg.
 * @param {number[][]} intervals Fixed leg payment interval in years. E.g., 0.5 represents semi-annual frequency.
 * @param {string[][]} payer_receivers Options include "Payer" or "Receiver".
 * @param {string} [custom_yield_curve] Optional. Specifies which user-defined yield curve to be used.
 * @param {string} [yield_curve] Optional. Specifies the yield curve to use. Options include SOFR, Treasury, AAA, AA, A, BBB, BB, B, CCC, and "Use Custom Yield Curve". The default is SOFR.
 * @param {CustomFunctions.Invocation} invocation Invocation object.
 * @returns {string} Writes valuation results below the calling cell and returns "Calculation successful." when successful.
 * @requiresAddress
 */
   function Swap(valuation_date, start_date, terms, swap_rates, intervals, payer_receivers, custom_yield_curve, yield_curve, invocation) {
    // Lock current sheet.
    return LockSheet().then((res)=>{
      try {
        const apiUrl = hostUrl + "fixedincomeproduct/swaps/";
        var cellAddress = invocation.address.split("!");    // sheet1!A9
        var termArr = [];
        terms.forEach(r => {
          r.forEach(c => {
            termArr.push(c);
          });
        });
        var swapRateArr = [];
        swap_rates.forEach(r => {
          r.forEach(c => {
            swapRateArr.push(c);
          });
        });
    
        var isPayerArr = [];
        payer_receivers.forEach(r => {
          r.forEach(c => {
            isPayerArr.push(c);
          });
        });
    
        var intervalArr = [];
        intervals.forEach(r => {
          r.forEach(c => {
            intervalArr.push(c);
          });
        });
        if (termArr.length != swapRateArr.length || 
          termArr.length != isPayerArr.length || 
          termArr.length != intervalArr.length){
          throw Error("The lengths of the task's parameters are not equal.")
        }
        var batchTask = {
          need_notify: false,
          use_own_data: false,
          valuation_date: valuation_date != null ? ToDateStr(valuation_date) : null,
          user_sofr_curve: custom_yield_curve != null ? custom_yield_curve : null,
          yield_curve: yield_curve != null ? yield_curve : (custom_yield_curve != null ? "Use Custom Yield Curve" : "SOFR"),
          tasks: []
        };
        var sd = ToDateStr(start_date);
        for (let i = 0; i < termArr.length; i++){
          var task = {
            row_id: i.toString(),
            term: termArr[i],
            swap_rate: swapRateArr[i],
            is_payer: isPayerArr[i],
            interval: intervalArr[i],
            start_date: sd
          };
          batchTask.tasks.push(task);
        };
        //return JSON.stringify(batchTask);

        // Submit tasks to plutus API, and get result
        if (batchTask.tasks.length <= 0){
          throw Error("No tasks submitted!");
        } else {
          return Rate_Prod_Calculate(batchTask, apiUrl, cellAddress);
        }
      } catch (error) {
        UnlockSheet();
        return error.toString();
      }
    });
  }

function Cap_Floor(valuation_date, terms, strikes, isCap = "Cap", term_structure = "SVSLN", custom_yield_curve = null, yield_curve = null, invocation) {
  // Lock current sheet.
  return LockSheet().then((res)=>{
    try {
      const apiUrl = hostUrl + "fixedincomeproduct/cap_floor/";
      var cellAddress = invocation.address.split("!");    // sheet1!A9

      var termArr = [];
      terms.forEach(r => {
        r.forEach(c => {
          termArr.push(c);
        });
      });

      var strikeArr = [];
      strikes.forEach(r => {
        r.forEach(c => {
          strikeArr.push(c);
        });
      });

      if (termArr.length != strikeArr.length){
        throw Error("The lengths of the task's parameters are not equal.")
      }
      var batchTask = {
        need_notify: false,
        use_own_data: false,
        valuation_date: valuation_date != null ? ToDateStr(valuation_date) : null,
        vol_type: term_structure == null ? "SVSLN" : term_structure,
        user_sofr_curve: custom_yield_curve != null ? custom_yield_curve : null,
        yield_curve: yield_curve != null ? yield_curve : (custom_yield_curve != null ? "Use Custom Yield Curve" : "SOFR"),
        tasks: []
      };
      for (let i = 0; i < termArr.length; i++){
        var task = {
          row_id: i.toString(),
          term: termArr[i],
          strike: strikeArr[i],
          is_cap: isCap
        };
        batchTask.tasks.push(task);
      };
      //return JSON.stringify(batchTask);

      // Submit tasks to plutus API, and get result
      if (batchTask.tasks.length <= 0){
        throw Error("No tasks submitted!");
      } else {
        return Rate_Prod_Calculate(batchTask, apiUrl, cellAddress);
      }
    } catch (error) {
      UnlockSheet();
      return error.toString();
    }
  });
}

/**
 * This function computes the price for Caps. The function returns the price, duration and convexity. 
 * @customfunction 
 * @param {string} valuation_date This is the date on which the yield curve and its volatility are used to price the bonds, e.g., 6/28/2024. This should reference a single cell.
 * @param {number[][]} terms Remaining term of the cap in years. For example, 5.5 means the remaining term of the cap is 5.5 years.
 * @param {number[][]} strikes This is the strike of the option, expressed as a decimal. For example, 0.045 for 4.5%. 
 * @param {string} [term_structure] Optional. Specifies which term structure model to be used. Options include SV and SVSLN. The default option is SVSLN. SVSLN is a multi-factor stochastic volatility shifted log-normal HJM model. SV is a multi-factor stochastic volatility HJM model.
 * @param {string} [custom_yield_curve] Optional. Specifies which user-defined yield curve to be used.
 * @param {string} [yield_curve] Optional. Specifies the yield curve to use. Options include SOFR, Treasury, AAA, AA, A, BBB, BB, B, CCC, and "Use Custom Yield Curve". The default is SOFR.
 * @param {CustomFunctions.Invocation} invocation Invocation object.
 * @returns {string} Writes valuation results below the calling cell and returns "Calculation successful." when successful.
 * @requiresAddress
 */
function Cap(valuation_date, terms, strikes, term_structure, custom_yield_curve, yield_curve, invocation) {
  return Cap_Floor(valuation_date, terms, strikes, "Cap", term_structure, custom_yield_curve, yield_curve, invocation);
}
/**
 * This function computes the price for Floors. The function returns the price, duration and convexity. 
 * @customfunction 
 * @param {string} valuation_date This is the date on which the yield curve and its volatility are used to price the bonds, e.g., 6/28/2024. This should reference a single cell.
 * @param {number[][]} terms Remaining term of the floor in years. For example, 5.5 means the remaining term of the floor is 5.5 years.
 * @param {number[][]} strikes This is the strike of the option, expressed as a decimal. For example, 0.045 for 4.5%. 
 * @param {string} [term_structure] Optional. Specifies which term structure model to be used. Options include SV and SVSLN. The default option is SVSLN. SVSLN is a multi-factor stochastic volatility shifted log-normal HJM model. SV is a multi-factor stochastic volatility HJM model.
 * @param {string} [custom_yield_curve] Optional. Specifies which user-defined yield curve to be used.
 * @param {string} [yield_curve] Optional. Specifies the yield curve to use. Options include SOFR, Treasury, AAA, AA, A, BBB, BB, B, CCC, and "Use Custom Yield Curve". The default is SOFR.
 * @param {CustomFunctions.Invocation} invocation Invocation object.
 * @returns {string} Writes valuation results below the calling cell and returns "Calculation successful." when successful.
 * @requiresAddress
 */
 function Floor(valuation_date, terms, strikes, term_structure, custom_yield_curve, yield_curve, invocation) {
  return Cap_Floor(valuation_date, terms, strikes, "Floor", term_structure, custom_yield_curve, yield_curve, invocation);
}

/**
 * This function computes the price for European swaption(s). The function returns the price, duration and convexity.
 * @customfunction 
 * @param {string} valuation_date This is the date on which the yield curve and its volatility are used to price the bonds, e.g., 6/28/2024. This should reference a single cell.
 * @param {number[][]} expiries Expiry of the swaption in years. For example, 5.5 means the option will expire in 5.5 years.
 * @param {number[][]} strikes This is the strike of the option, expressed as a decimal. For example, 0.045 for 4.5%. 
 * @param {number[][]} tenors This is the final expiry of the option, measured in years. For example, 5.5 means the option will expire in 5.5 years.
 * @param {string[][]} payer_receivers Options include "Payer" or "Receiver".
 * @param {string} [term_structure] Optional. Specifies which term structure model to be used. Options include SV and SVSLN. The default option is SVSLN. SVSLN is a multi-factor stochastic volatility shifted log-normal HJM model. SV is a multi-factor stochastic volatility HJM model.
 * @param {string} [custom_yield_curve] Optional. Specifies which user-defined yield curve to be used.
 * @param {string} [yield_curve] Optional. Specifies the yield curve to use. Options include SOFR, Treasury, AAA, AA, A, BBB, BB, B, CCC, and "Use Custom Yield Curve". The default is SOFR.
 * @param {CustomFunctions.Invocation} invocation Invocation object.
 * @returns {string} Writes valuation results below the calling cell and returns "Calculation successful." when successful.
 * @requiresAddress
 */
function European_Swaption(valuation_date, expiries, strikes, tenors, payer_receivers, term_structure, custom_yield_curve, yield_curve, invocation) {
  // Lock current sheet.
  console.log(valuation_date);
  return LockSheet().then((res)=>{
    try {
      const apiUrl = hostUrl + "fixedincomeproduct/euro_swptn/";
      var cellAddress = invocation.address.split("!");    // sheet1!A9

      var expiryArr = [];
      expiries.forEach(r => {
        r.forEach(c => {
          expiryArr.push(c);
        });
      });

      var strikeArr = [];
      strikes.forEach(r => {
        r.forEach(c => {
          strikeArr.push(c);
        });
      });

      var tenorArr = [];
      tenors.forEach(r => {
        r.forEach(c => {
          tenorArr.push(c);
        });
      });

      var isPayerArr = [];
      payer_receivers.forEach(r => {
        r.forEach(c => {
          isPayerArr.push(c);
        });
      });

      if (expiryArr.length != strikeArr.length || 
        expiryArr.length != tenorArr.length || 
        expiryArr.length != isPayerArr.length){
        throw Error("The lengths of the task's parameters are not equal.")
      }
      var batchTask = {
        need_notify: false,
        use_own_data: false,
        valuation_date: valuation_date != null ? ToDateStr(valuation_date) : null,
        vol_type: term_structure == null ? "SVSLN" : term_structure,
        user_sofr_curve: custom_yield_curve != null ? custom_yield_curve : null,
        yield_curve: yield_curve != null ? yield_curve : (custom_yield_curve != null ? "Use Custom Yield Curve" : "SOFR"),
        tasks: []
      };
      for (let i = 0; i < expiryArr.length; i++){
        var task = {
          row_id: i.toString(),
          expiry: expiryArr[i],
          strike: strikeArr[i],
          tenor: tenorArr[i],
          is_payer: isPayerArr[i]
        };
        batchTask.tasks.push(task);
      };
      //return JSON.stringify(batchTask);

      // Submit tasks to plutus API, and get result
      if (batchTask.tasks.length <= 0){
        throw Error("No tasks submitted!");
      } else {
        return Rate_Prod_Calculate(batchTask, apiUrl, cellAddress, ['price', 'duration', 'convexity', 'impbkvol']);
      }
    } catch (error) {
      UnlockSheet();
      return error.toString();
    }
  });
}

/**
 * This function computes the price for European zero coupon swaption(s). The function returns the price, duration and convexity.
 * @customfunction 
 * @param {string} valuation_date This is the date on which the yield curve and its volatility are used to price the bonds, e.g., 6/28/2024. This should reference a single cell.
 * @param {number[][]} expiries Expiry of the swaption in years. For example, 5.5 means the option will expire in 5.5 years.
 * @param {number[][]} strikes This is the strike of the option, expressed as a decimal. For example, 0.045 for 4.5%. 
 * @param {number[][]} tenors This is the final expiry of the option, measured in years. For example, 5.5 means the option will expire in 5.5 years.
 * @param {string[][]} payer_receivers Options include "Payer" or "Receiver".
 * @param {string} [term_structure] Optional. Specifies which term structure model to be used. Options include SV and SVSLN. The default option is SVSLN. SVSLN is a multi-factor stochastic volatility shifted log-normal HJM model. SV is a multi-factor stochastic volatility HJM model.
 * @param {string} [custom_yield_curve] Optional. Specifies which user-defined yield curve to be used.
 * @param {string} [yield_curve] Optional. Specifies the yield curve to use. Options include SOFR, Treasury, AAA, AA, A, BBB, BB, B, CCC, and "Use Custom Yield Curve". The default is SOFR.
 * @param {CustomFunctions.Invocation} invocation Invocation object.
 * @returns {string} Writes valuation results below the calling cell and returns "Calculation successful." when successful.
 * @requiresAddress
 */
function European_ZC_Swaption(valuation_date, expiries, strikes, tenors, payer_receivers, term_structure, custom_yield_curve, yield_curve, invocation) {
  // Lock current sheet.
  console.log(valuation_date);
  return LockSheet().then((res)=>{
    try {
      const apiUrl = hostUrl + "fixedincomeproduct/euro_zc_swptn/";
      var cellAddress = invocation.address.split("!");    // sheet1!A9

      var expiryArr = [];
      expiries.forEach(r => {
        r.forEach(c => {
          expiryArr.push(c);
        });
      });

      var strikeArr = [];
      strikes.forEach(r => {
        r.forEach(c => {
          strikeArr.push(c);
        });
      });

      var tenorArr = [];
      tenors.forEach(r => {
        r.forEach(c => {
          tenorArr.push(c);
        });
      });

      var isPayerArr = [];
      payer_receivers.forEach(r => {
        r.forEach(c => {
          isPayerArr.push(c);
        });
      });

      if (expiryArr.length != strikeArr.length || 
        expiryArr.length != tenorArr.length || 
        expiryArr.length != isPayerArr.length){
        throw Error("The lengths of the task's parameters are not equal.")
      }
      var batchTask = {
        need_notify: false,
        use_own_data: false,
        valuation_date: valuation_date != null ? ToDateStr(valuation_date) : null,
        vol_type: term_structure == null ? "SVSLN" : term_structure,
        user_sofr_curve: custom_yield_curve != null ? custom_yield_curve : null,
        yield_curve: yield_curve != null ? yield_curve : (custom_yield_curve != null ? "Use Custom Yield Curve" : "SOFR"),
        tasks: []
      };
      for (let i = 0; i < expiryArr.length; i++){
        var task = {
          row_id: i.toString(),
          expiry: expiryArr[i],
          strike: strikeArr[i],
          tenor: tenorArr[i],
          is_payer: isPayerArr[i]
        };
        batchTask.tasks.push(task);
      };
      //return JSON.stringify(batchTask);

      // Submit tasks to plutus API, and get result
      if (batchTask.tasks.length <= 0){
        throw Error("No tasks submitted!");
      } else {
        return Rate_Prod_Calculate(batchTask, apiUrl, cellAddress, ['price', 'duration', 'convexity', 'impbkvol']);
      }
    } catch (error) {
      UnlockSheet();
      return error.toString();
    }
  });
}

/**
 * This function computes the price for Bermudan or American swaption(s). The function returns the price, duration and convexity.
 * @customfunction 
 * @param {string} valuation_date This is the date on which the yield curve and its volatility are used to price the derivatives, e.g., 6/28/2024. This should reference a single cell.
 * @param {number[][]} lockouts This is the lockout period of the option, measured in years. For example, 2.5 means the lockout period is 2.5 years.
 * @param {number[][]} tenors This is the final expiry of the option, measured in years. For example, 5.5 means the option will expire in 5.5 years.
 * @param {number[][]} strikes This is the strike of the option, expressed as a decimal. For example, 0.045 for 4.5%. 
 * @param {number[][]} call_frequencies The number of call dates per year. Must be an integer (e.g., 2 for semi-annual calls).
 * @param {string[][]} payer_receivers Options include "Payer" or "Receiver".
 * @param {string} [term_structure] Optional. Specifies which term structure model to be used. Options include SV and SVSLN. The default option is SVSLN. SVSLN is a multi-factor stochastic volatility shifted log-normal HJM model. SV is a multi-factor stochastic volatility HJM model.
 * @param {string} [custom_yield_curve] Optional. Specifies which user-defined yield curve to be used.
 * @param {string} [yield_curve] Optional. Specifies the yield curve to use. Options include SOFR, Treasury, AAA, AA, A, BBB, BB, B, CCC, and "Use Custom Yield Curve". The default is SOFR.
 * @param {CustomFunctions.Invocation} invocation Invocation object.
 * @returns {string} Writes valuation results below the calling cell and returns "Calculation successful." when successful.
 * @requiresAddress
 */
function Bermudan_Swaption(valuation_date, lockouts, tenors, strikes, call_frequencies, payer_receivers, term_structure, custom_yield_curve, yield_curve, invocation) {
  // Lock current sheet.
  return LockSheet().then((res)=>{
    try {
      const apiUrl = hostUrl + "fixedincomeproduct/berm_swptn/";
      var cellAddress = invocation.address.split("!");    // sheet1!A9
      var lockoutArr = [];
      lockouts.forEach(r => {
        r.forEach(c => {
          lockoutArr.push(c);
        });
      });

      var strikeArr = [];
      strikes.forEach(r => {
        r.forEach(c => {
          strikeArr.push(c);
        });
      });

      var tenorArr = [];
      tenors.forEach(r => {
        r.forEach(c => {
          tenorArr.push(c);
        });
      });

      var callFrequenceArr = [];
      call_frequencies.forEach(r => {
        r.forEach(c => {
          callFrequenceArr.push(c);
        });
      });

      var isPayerArr = [];
      payer_receivers.forEach(r => {
        r.forEach(c => {
          isPayerArr.push(c);
        });
      });

      if (lockoutArr.length != strikeArr.length || 
        lockoutArr.length != tenorArr.length || 
        lockoutArr.length != callFrequenceArr.length || 
        lockoutArr.length != isPayerArr.length){
        throw Error("The lengths of the task's parameters are not equal.")
      }
      var batchTask = {
        need_notify: false,
        use_own_data: false,
        valuation_date: valuation_date != null ? ToDateStr(valuation_date) : null,
        vol_type: term_structure == null ? "SVSLN" : term_structure,
        user_sofr_curve: custom_yield_curve != null ? custom_yield_curve : null,
        yield_curve: yield_curve != null ? yield_curve : (custom_yield_curve != null ? "Use Custom Yield Curve" : "SOFR"),
        tasks: []
      };
      for (let i = 0; i < lockoutArr.length; i++){
        var task = {
          row_id: i.toString(),
          lockout: lockoutArr[i],
          strike: strikeArr[i],
          tenor: tenorArr[i],
          call_freq: callFrequenceArr[i],
          is_payer: isPayerArr[i]
        };
        batchTask.tasks.push(task);
      };
      //return JSON.stringify(batchTask);

      // Submit tasks to plutus API, and get result
      if (batchTask.tasks.length <= 0){
        throw Error("No tasks submitted!");
      } else {
        return Rate_Prod_Calculate(batchTask, apiUrl, cellAddress);
      }
    } catch (error) {
      UnlockSheet();
      return error.toString();
    }
  });
}
CustomFunctions.associate("MBS_PRICE", MBS_Price);
CustomFunctions.associate("MBS_OAS", MBS_OAS);
CustomFunctions.associate("EUROPEAN_CALLABLE_OAS", European_Callable_OAS);
CustomFunctions.associate("EUROPEAN_CALLABLE_PRICE", European_Callable_Price);
CustomFunctions.associate("FIXED_RATE_BULLET", Fixed_Rate_Bullet);
CustomFunctions.associate("FLOATER", Floater);
CustomFunctions.associate("FLOATER_WITH_FLOOR", Floater_With_Floor);
CustomFunctions.associate("BERMUDAN_CALLABLE_OAS", Bermudan_Callable_OAS);
CustomFunctions.associate("BERMUDAN_CALLABLE_PRICE", Bermudan_Callable_Price);
CustomFunctions.associate("SWAP", Swap);
CustomFunctions.associate("CAP", Cap);
CustomFunctions.associate("FLOOR", Floor);
CustomFunctions.associate("EUROPEAN_SWAPTION", European_Swaption);
CustomFunctions.associate("EUROPEAN_ZC_SWAPTION", European_ZC_Swaption);
CustomFunctions.associate("BERMUDAN_SWAPTION", Bermudan_Swaption);